import { PT_HUB_ALTERNATES } from '../../../../../components/market/PtTopicPage'

// Dubai personal trainer hub. No trainer roster (none in Dubai yet).
const content = {
    title: (c) => `Personal Trainer Dubai from ${c.money(c.lowest, 0)}/Session | Home & Building Gym`,
    description: (c) =>
        `Certified personal trainers in Dubai at your home, building gym or outdoors. Packages from ${c.money(c.lowest, 0)} a session. Tell us your goal and we match you.`,
    eyebrow: 'Dubai',
    h1: 'Personal Trainer in Dubai',
    heroCopy: (c) =>
        `A certified trainer matched to your goal, at your apartment, building gym or the beach. From ${c.money(c.lowest, 0)} a session.`,
    image: 'personal-trainer/personal-trainer.jpg',
    imageAlt: 'Personal trainer coaching a client through a workout',
    facts: ['Home, building gym or outdoors', 'Signature and Elite trainers', 'Partner training option'],
    packagesTitle: 'Personal training packages in Dubai',
    packagesIntro: 'Prices are per session. Longer packages cost less per session. Partner training splits a session between two people.',
    sections: [
        {
            title: 'Training in Dubai, month by month',
            cards: [
                { title: 'October to April', body: 'The best months for outdoor sessions - beach workouts at Kite Beach or JBR, runs along the Marina walk, park circuits in Zabeel Park.' },
                { title: 'May to September', body: 'Training moves indoors: your building gym, a home setup, or very early mornings before the heat. Your trainer plans around it.' },
                { title: 'November to December', body: 'Dubai Fitness Challenge season - a good moment to start, with the whole city moving for 30 days.' },
                { title: 'Ramadan', body: 'Sessions shift to just before Iftar or late evening, with lighter intensity while fasting.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'Where your sessions happen',
            tone: 'muted',
            items: [
                'At home - your trainer brings portable kit: bands, kettlebells, mats.',
                'In your building or community gym - most Dubai towers have one; check guest-trainer rules with management.',
                'Outdoors in the cooler months - beach, park or running track.',
                'Online, for travel weeks or as a check-in between in-person sessions.',
            ],
            columns: 2,
        },
    ],
    faqs: [
        {
            question: 'How much does a personal trainer cost in Dubai?',
            answer: (c) => `With StringsSG, ${c.money(c.pt('Signature', 14), 0)} a session on a 14-session package, falling to ${c.money(c.pt('Signature', 50), 0)} on 50 sessions. Elite trainers with 5+ years\' experience cost ${c.money(c.pt('Elite', 14), 0)} to ${c.money(c.pt('Elite', 50), 0)} a session.`,
        },
        {
            question: 'Can the trainer come to my building gym?',
            answer: 'Usually yes. Many Dubai buildings allow residents to bring a personal trainer; some ask for the trainer\'s ID or a small registration. Check with your building management.',
        },
        {
            question: 'Do you have female personal trainers in Dubai?',
            answer: (c) => `Yes, you can request a female trainer. A female-trainer preference adds ${c.money(c.mods.female, 0)} a session.`,
        },
        {
            question: 'Are your trainers certified?',
            answer: 'We work with trainers who hold recognised fitness certifications and the registration and permits needed to train clients in the UAE.',
        },
    ],
    schema: { name: 'Personal Trainer in Dubai' },
    alternates: PT_HUB_ALTERNATES,
}

export default content
